"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UITextToolbarButton = _interopRequireDefault(require("UIComponents/editor/UITextToolbarButton"));

var _UITextToolbarIcon = _interopRequireDefault(require("UIComponents/editor/UITextToolbarIcon"));

var _withDisabledContext = _interopRequireDefault(require("../hoc/withDisabledContext"));

var ToolbarButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ToolbarButton, _Component);

  function ToolbarButton() {
    (0, _classCallCheck2.default)(this, ToolbarButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToolbarButton).apply(this, arguments));
  }

  (0, _createClass2.default)(ToolbarButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconName = _this$props.iconName,
          tooltip = _this$props.tooltip,
          placement = _this$props.placement,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          buttonProps = (0, _objectWithoutProperties2.default)(_this$props, ["iconName", "tooltip", "placement", "onClick", "disabled"]);
      return _react.default.createElement(_UITooltip.default, {
        disabled: disabled,
        title: tooltip,
        placement: placement
      }, _react.default.createElement(_UITextToolbarButton.default, (0, _extends2.default)({
        onClick: onClick,
        disabled: disabled
      }, buttonProps), _react.default.createElement(_UITextToolbarIcon.default, {
        disabled: disabled,
        name: iconName
      })));
    }
  }]);
  return ToolbarButton;
}(_react.Component);

ToolbarButton.propTypes = {
  iconName: _react.PropTypes.string.isRequired,
  tooltip: _react.PropTypes.string.isRequired,
  placement: _react.PropTypes.string,
  onClick: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool
};
ToolbarButton.defaultProps = {
  placement: 'bottom'
};

var _default = (0, _withDisabledContext.default)(ToolbarButton);

exports.default = _default;
module.exports = exports.default;